import React from "react";
import hero from "../images/hero.jpg";

function Hero() {
  return (
    <div className="hero">
      <img src={hero} alt="Boutique Banner" />
      <div className="hero-text">
        <h1>Elegant Fashion Boutique</h1>
        <p>Designer Sarees • Suits • Kurtis</p>
        <button className="primary-btn">Shop Now</button>

      </div>
    </div>
  );
}

export default Hero;
